function formatAmount(amount) {
    if (amount === null || amount === undefined) return "-";
    var value = Number(amount);
    return value.toLocaleString("ru-RU", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " \u20BD";
}

function normalizeItem(raw) {
    return {
        id: raw.id,
        status: raw.status,
        amount: Number(raw.amount) / 100,
        fullName: raw.full_name,
        cardPanMasked: raw.card_pan_masked,
        payoutType: raw.payout_type,
        sbpPhone: raw.sbp_phone,
        sbpBankCode: raw.sbp_bank_code || raw.sbp_bank_bic,
        sbpBankName: raw.sbp_bank_name,
        documentDate: raw.document_date,
        externalReference: raw.external_reference,
    };
}

var STATUS_NAMES = {
    0: "Создана",
    1: "Антифрод",
    2: "Отклонена",
    3: "Реестр",
    4: "В работе",
    5: "Успех",
    6: "Ошибка",
    7: "Ожидает",
};

var REGISTRY_STATUS = {
    0: { label: "Создан", bg: "#e3f2fd", color: "#1565c0" },
    1: { label: "В обработке", bg: "#fff3e0", color: "#e65100" },
    2: { label: "Обработан", bg: "#e8f5e9", color: "#2e7d32" },
    3: { label: "Ошибки", bg: "#fce4ec", color: "#ad1457" },
    4: { label: "Отложен", bg: "#f5f5f5", color: "#616161" },
};

export { formatAmount, normalizeItem, STATUS_NAMES, REGISTRY_STATUS };
export default { formatAmount, normalizeItem, STATUS_NAMES, REGISTRY_STATUS };



// WEBPACK FOOTER //
// ./src/Components/ComponentsOfAdministrator/CrmRegistryModal/CrmRegistryModalUtils.js